import BaseApiService from '@/services/common/api/baseApiService';

class RolesService extends BaseApiService {
  getRoles() {
    return this.makeRequest(this.httpClient.get(this.apiRoutes.roles));
  }
}

export default RolesService;
